var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.GET_ALERT_STATUS.status)?_c('div',{staticClass:"alert--overlay"},[_c('div',{staticClass:"alert--container"},[_c(_vm.currentComponent,{tag:"component"})],1)]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }